import { DOMAIN_COUNTRY_MAP } from '@/src/constants/domain'
import { isNxItineraryId } from '../itinerary/isNxItineraryId'

const ITINEX_PREFIX = '/bff/orbit/v1'

const NORMAL_NI_DOMAINS = ['B2E']

export const getItineraryEndpointPath = (itineraryId: string, path: string) => {
    const isNxId = isNxItineraryId(itineraryId)
    return isNxId ? `${ITINEX_PREFIX}${path}` : path
}

export const getCreateItineraryEndpointPath = (path: string, { multiCity = false }: { multiCity?: boolean } = {}) => {
    const origin = typeof window !== 'undefined' ? window.location.origin : ''
    const domain = DOMAIN_COUNTRY_MAP[origin]
    const isNormalNiDomain = !!domain && NORMAL_NI_DOMAINS.includes(domain)

    // Multi-city is only supported on the itinex/orbit BFF, so it always uses itinex.
    const isItinex = multiCity || !isNormalNiDomain

    return isItinex ? `${ITINEX_PREFIX}${path}` : path
}

export default getItineraryEndpointPath
